export const BLACK_AND_WHITE = "black and white";
export const COLORED = "colored";
